var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M0 .972v10.056c0 .767.836 1.233 1.48.815l7.823-5.028a.976.976 0 0 0 0-1.64L1.48.157C.836-.261 0 .205 0 .972"
})));
export { SvgVideoIcon as ReactComponent };
export default __webpack_public_path__ + "99889a5aafafe167d36d2defd6c4cde2.svg";